import * as service from "./../../service";

export default ({ name, data, query }) => ({
    name,
    data,
    model: {
        prop: ["value"],
        event: "change"
    },
    created() {
        this.query();
    },
    watch: {
        "$i18n.locale"() {
            this.query();
        }
    },
    props: {
        value: [Array, Number, String]
    },
    methods: {
        query,
        onChange(value) {
            this.$emit("change", value);
        },
        listAgent() {
            return service.listAgent();
        },
        listAgentGroup() {
            return service.listAgentGroup();
        }
    }
});
